import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-form-realizar-consulta',
  templateUrl: './modal-form-realizar-consulta.component.html',
  styleUrls: ['./modal-form-realizar-consulta.component.scss']
})
export class ModalFormRealizarConsultaComponent implements OnInit {

  @Input() tipoPesquisaVeiculo: String;
  @Input() formValues: any;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}
